import * as BobPlayer from "./BobPlayer/index.js";
import * as CacheBuilder from "./CacheBuilder/index.js";
import * as GeoEntityDataVerification from "./GeoEntityDataVerification/index.js";
import * as ListingActivityReport from "./ListingActivityReport/index.js";
import * as ListingLead from "./ListingLead/index.js";
import * as ListingServiceScheduler from "./ListingServiceScheduler/index.js";
import * as Enums from "./Enums/index.js";
/** CoStar.Api.ListingAlert.ViewModels.NotificationMessageType */
export var NotificationMessageType;
(function (NotificationMessageType) {
    NotificationMessageType[NotificationMessageType["None"] = 0] = "None";
    NotificationMessageType[NotificationMessageType["WatchListing"] = 1] = "WatchListing";
    NotificationMessageType[NotificationMessageType["LeadMessage"] = 2] = "LeadMessage";
    NotificationMessageType[NotificationMessageType["SavedSearch"] = 3] = "SavedSearch";
    NotificationMessageType[NotificationMessageType["TestMessage"] = 9999] = "TestMessage";
})(NotificationMessageType || (NotificationMessageType = {}));
/** CoStar.Api.ListingAlert.ViewModels.ListingMatchReason */
export var ListingMatchReason;
(function (ListingMatchReason) {
    ListingMatchReason[ListingMatchReason["None"] = 0] = "None";
    ListingMatchReason[ListingMatchReason["ListingCreated"] = 1] = "ListingCreated";
    ListingMatchReason[ListingMatchReason["NewSpaceFound"] = 2] = "NewSpaceFound";
})(ListingMatchReason || (ListingMatchReason = {}));
export { BobPlayer, CacheBuilder, GeoEntityDataVerification, ListingActivityReport, ListingLead, ListingServiceScheduler, Enums };
